import { isNameUnique } from './cohort-definition-validation/isNameUnique';

// This utility function checks if the name is unique for an event.
// It returns an object containing the error message and a boolean flag.
export const validateName = (
  id: string,
  value: string,
  subjectVariables: any[] = [],
  derivedEvents: any[] = [],
  simpleEvents: any[] = []
) => {
  const unique = isNameUnique(id, value, subjectVariables, derivedEvents, simpleEvents);
  if (unique) {
    return {
      errorMsg: '',
      hasError: false,
    };
  } else {
    return {
      errorMsg: 'Duplicate variable name. Please enter a unique variable name.',
      hasError: true,
    };
  }
};
